import './forecast-boxes-popup.scss'
import { FC, useState, useEffect, useCallback } from "react"
import { Button } from "primereact/button"
import { InputText } from "primereact/inputtext"
import { addICProductsByShop, getICProductsByShop, getICForecastBoxes } from '../../productSlices'
import { useDispatch, useSelector } from 'react-redux'
import ForecastBoxesTable from '../forecast-boxes-table/forecast-boxes-table'
import { MultiSelect } from 'primereact/multiselect'
import { updateShopConfig } from '../../shopSlices'
import { useLocation, useNavigate } from 'react-router-dom'
import { refreshUserInfos } from 'features/authentication/authSlices'
import { Dropdown } from 'primereact/dropdown'
interface ForecastBoxesPopupProps {
    fullCommentary:string,
    isVisible:boolean,
    setVisible:Function,
    filtersSelectedShopExternal:string,
    filtersSelectedProductExternal:string
}
const selectedProductTemplate = (option) => {
  const name = option?.name || 'Select a product';  
  return (
      <div className="shop-selected">
          <div className="shop__details__name">{name}</div>
      </div>
  );
}
const optionTemplate = (option) => {
  return (
      <div className="shop">
          <div>{option.name}</div>
      </div>
  );
};
const ForecastBoxesPopup : FC<ForecastBoxesPopupProps>= ({fullCommentary, isVisible,setVisible, filtersSelectedShopExternal, filtersSelectedProductExternal}) => {
    const dispatch: Function = useDispatch();
    const [selectedBoxes, setSelectedBoxes] = useState({});
    const user = useSelector((state: any) => state.auth.user);
    const userShops = user.shops;
    const shopsOptions = userShops.map((shop: any) => ({ name: shop.name, value: shop.id }));
    const selectedShop = useSelector((state: any) => state.user.selectedShop);
    const [filtersSelectedShop, setFiltersSelectedShop] = useState(null)
    const [tempSelectedBoxes, setTempSelectedBoxes] = useState({});
    const [config, setConfig] = useState({});
    const navigate = useNavigate();
    const location = useLocation()
    useEffect(()=>{
      dispatch(getICProductsByShop(filtersSelectedShop))
    },[filtersSelectedShop])

    const getConfig = useCallback(() =>{
      if(!filtersSelectedShop) return;
      const selectedShop = user.shops.find((shop: any) => shop.id === filtersSelectedShop);
      if(!selectedShop) return;
      const selectedShopConfig = JSON.parse(selectedShop.config);
      return selectedShopConfig
    }, [filtersSelectedShop, user.shops])

    useEffect(() => {
      if(!filtersSelectedShop) return;
      const selectedShopConfig = getConfig()
      setSelectedBoxes(selectedShopConfig)
      setTempSelectedBoxes(selectedShopConfig)
      
    }, [filtersSelectedShop, user.shops])
    useEffect(() => {
      if(filtersSelectedShopExternal && filtersSelectedProductExternal) {
        dispatch(getICForecastBoxes(filtersSelectedShopExternal, filtersSelectedProductExternal))
      }
    }, [filtersSelectedShopExternal, filtersSelectedProductExternal, getConfig()])

    const saveBoxes = () => {
        dispatch(updateShopConfig(filtersSelectedShop, selectedBoxes))
        setVisible(false);
        refreshUserInfos(dispatch, navigate, location)
        if(filtersSelectedShopExternal && filtersSelectedProductExternal) {
          dispatch(getICForecastBoxes(filtersSelectedShopExternal, filtersSelectedProductExternal))
        }
    }

    const handleCancel = () => {
        setSelectedBoxes(tempSelectedBoxes);
        setVisible(false);
    }
    
    return (
      <>
      <div className="mask"></div>
      <div className="popup">
        <div className={`forecast-boxes-popup ${isVisible ? 'visible' : ''}`}>
          <div className="forecast-boxes-popup__header">
            <div className="forecast-boxes-popup__header__titles">
              <div className="forecast-boxes-popup__header__titles__title">Update which flavor is in 3L boxes / 5L boxes / 7L boxes</div>
            </div>
            <Button onClick={() => setVisible(false)} icon="pi pi-times" iconPos='right' className="forecast-boxes-popup__header__close-button" />
          </div>
          <div className="forecast-boxes-popup__content">
          <Dropdown value={filtersSelectedShop} onChange={(e) =>setFiltersSelectedShop(e.value)} options={shopsOptions} optionLabel="name" placeholder="Select a shop" 
              itemTemplate={optionTemplate} filterTemplate={selectedProductTemplate} className="shop-dropdown"
                />
            {selectedBoxes && filtersSelectedShop && <ForecastBoxesTable selectedBoxes={selectedBoxes} setSelectedBoxes={setSelectedBoxes}/>}
          </div>
          <div className="forecast-boxes-popup__footer">
            <Button onClick={handleCancel} iconPos='right' label={'Cancel'} className="forecast-boxes-popup__footer__cancel-button" />
            <Button onClick={saveBoxes} iconPos='right' label={'Confirm'} className="forecast-boxes-popup__footer__confirm-button" />
          </div>
        </div>
      </div>
      </>
    )
}

export default ForecastBoxesPopup